itsoftApp.createModule("inputMask", function() {

    if ($(".input-mask").length) {

        itsoftApp.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.10/jquery.mask.js", function() {

            $(".input__value--phone").mask('9999999999');

        });

    }
});
